export { DMS_MODULE } from '../constants';
export const NAME = 'WmsSecurityguard';
export const API_NAME = 'WmsSecurityguard';
export const CRUMB_LABEL_KEY = 'WmsSecurityguard';
